import React from "react";
import { Link } from "react-router-dom";
import {useSelector} from "react-redux";

const NavBar = () => {
    const { user } = useSelector((state) => state.auth);

    // Helper to get user name (handle both nested and plain structures)
    const getUserName = () => {
        // Since we normalize user object in authSlice, it should always be plain
        return user?.name || "User";
    };

    // Helper to get user type
    const getUserType = () => {
        return user?.type || "";
    };

    // Helper to get role name (handle both string ID and object)
    const getRoleName = () => {
        const role = user?.role;
        if (!role) return "";
        // If role is an object with name property
        if (typeof role === "object" && role?.name) {
            return role.name;
        }
        // If role is just an ID string, return empty
        return "";
    };

    const userName = getUserName();
    const userType = getUserType();
    const roleName = getRoleName();

    return (
        <nav className="bg-lightSecondary text-white p-4">
            <div className="container mx-auto flex justify-between items-center">
                <div className="text-2xl font-bold">
                    <Link to="/dashboard">Admin Portal</Link>
                </div>
                <div className="flex items-center gap-4">
                    <div className="flex flex-col">
                        <p className="font-bold">
                            {userName}
                        </p>
                        <p className="text-sm">
                            {roleName}
                        </p>
                    </div>
                    {/*<div className="flex flex-col items-end">*/}
                    {/*    <span className="text-white font-semibold">*/}
                    {/*    */}
                    {/*    </span>*/}
                    {/*    <div className="flex items-center gap-2 text-sm text-gray-200">*/}
                    {/*        /!* {userType && (*/}
                    {/*            <span className="px-2 py-1 bg-primary/30 rounded">*/}
                    {/*                {userType}*/}
                    {/*            </span>*/}
                    {/*        )} *!/*/}
                    {/*        /!* {roleName && (*/}
                    {/*            <span className="px-2 py-1 bg-primary/30 rounded">*/}
                    {/*                {roleName}*/}
                    {/*            </span>*/}
                    {/*        )} *!/*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </nav>
    );
};

export default NavBar;
